import { Tag, Plus, ToggleLeft, ToggleRight, Trash2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import {
    Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../../components/ui/table';

export const PromoCodesAdminTab = ({
    setPromoDialogOpen,
    promoCodes,
    handleTogglePromo,
    handleDeletePromo,
    promoRedemptions,
}) => (
    <div className="card-dark p-6">
        <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <Tag className="w-5 h-5 text-[#FFD700]" />
                Promo Codes
            </h3>
            <Button onClick={() => setPromoDialogOpen(true)} className="btn-primary" data-testid="create-promo-btn">
                <Plus className="w-4 h-4 mr-2" />Create Promo
            </Button>
        </div>

        {promoCodes.length === 0 ? (
            <p className="text-center text-[#A0AAB2] py-12">No promo codes yet. Create your first one!</p>
        ) : (
            <div className="overflow-x-auto">
                <Table>
                    <TableHeader>
                        <TableRow className="border-white/10">
                            <TableHead className="text-[#A0AAB2]">Code</TableHead>
                            <TableHead className="text-[#A0AAB2]">Type</TableHead>
                            <TableHead className="text-[#A0AAB2] text-right">Amount</TableHead>
                            <TableHead className="text-[#A0AAB2] text-right">Uses</TableHead>
                            <TableHead className="text-[#A0AAB2]">Status</TableHead>
                            <TableHead className="text-[#A0AAB2]">Expires</TableHead>
                            <TableHead className="text-[#A0AAB2] text-right">Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {promoCodes.map((p, i) => (
                            <TableRow key={p.code} className="border-white/10" data-testid={`promo-row-${i}`}>
                                <TableCell className="font-mono font-bold text-[#FFD700]">{p.code}</TableCell>
                                <TableCell>
                                    <span className={`px-2 py-1 rounded text-xs font-medium ${
                                        p.bonus_type === 'credits' ? 'bg-[#39FF14]/20 text-[#39FF14]'
                                        : p.bonus_type === 'free_spins' ? 'bg-[#FF007F]/20 text-[#FF007F]'
                                        : 'bg-[#00FFFF]/20 text-[#00FFFF]'
                                    }`}>{p.bonus_type}</span>
                                </TableCell>
                                <TableCell className="text-right font-mono text-white">{p.amount}</TableCell>
                                <TableCell className="text-right font-mono text-[#A0AAB2]">
                                    {p.times_used || 0}{p.max_uses > 0 ? `/${p.max_uses}` : '/∞'}
                                </TableCell>
                                <TableCell>
                                    {p.is_active
                                        ? <span className="px-2 py-1 rounded-full text-xs font-bold bg-[#39FF14]/20 text-[#39FF14]">Active</span>
                                        : <span className="px-2 py-1 rounded-full text-xs font-bold bg-[#FF3B30]/20 text-[#FF3B30]">Inactive</span>
                                    }
                                </TableCell>
                                <TableCell className="text-[#A0AAB2] text-sm">
                                    {p.expires_at ? new Date(p.expires_at).toLocaleDateString('en-US', { timeZone: 'America/Chicago' }) : 'Never'}
                                </TableCell>
                                <TableCell className="text-right">
                                    <div className="flex items-center justify-end gap-1">
                                        <Button size="sm" variant="outline" onClick={() => handleTogglePromo(p.code, p.is_active)}
                                            className={`h-8 w-8 p-0 ${p.is_active ? 'border-yellow-500/30 text-yellow-500' : 'border-[#39FF14]/30 text-[#39FF14]'}`}
                                            data-testid={`toggle-promo-${i}`}
                                            title={p.is_active ? 'Deactivate' : 'Activate'}>
                                            {p.is_active ? <ToggleRight className="w-4 h-4" /> : <ToggleLeft className="w-4 h-4" />}
                                        </Button>
                                        <Button size="sm" variant="outline" onClick={() => handleDeletePromo(p.code)}
                                            className="border-[#FF3B30]/30 text-[#FF3B30] hover:bg-[#FF3B30]/10 h-8 w-8 p-0"
                                            data-testid={`delete-promo-${i}`}>
                                            <Trash2 className="w-4 h-4" />
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        )}

        {promoRedemptions.length > 0 && (
            <div className="mt-8">
                <h4 className="text-md font-bold text-white mb-4">Recent Redemptions</h4>
                <div className="space-y-2">
                    {promoRedemptions.slice(0, 10).map((r, i) => (
                        <div key={i} className="flex items-center justify-between p-3 rounded-lg bg-white/5">
                            <div className="flex items-center gap-3">
                                <span className="font-mono text-[#FFD700] text-sm font-bold">{r.promo_code}</span>
                                <span className="text-[#A0AAB2] text-sm">{r.user_name || r.user_email}</span>
                            </div>
                            <span className="text-[#A0AAB2] text-sm">{r.created_at ? new Date(r.created_at).toLocaleDateString('en-US', { timeZone: 'America/Chicago' }) : ''}</span>
                        </div>
                    ))}
                </div>
            </div>
        )}
    </div>
);
